"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOddsLadder = getOddsLadder;
async function getOddsLadder(priceFormatId) {
    const request = {
        header: this.header,
        integrationPartnerId: this.userContext !== undefined
            ? this.userContext?.integrationPartnerId
            : this.controllerDefaults.integrationPartnerId,
        priceFormat: priceFormatId,
    };
    return (await this.sendRequest('getOddsLadder.ashx', request));
}
